import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeComponent} from './home/home.component';
import {AboutComponent} from './about/about.component';
import {LoginComponent} from './login/login.component';
import {UserComponent} from './user/user.component';
import {SignupComponent} from './signup/signup.component';
import {ActivateGuard} from './activate.guard';
import {HeartComponent} from './user/heart/heart.component';
import {PredictionComponent} from './user/prediction/prediction.component';
import {AdminloginComponent} from './adminlogin/adminlogin.component';
import {AdminComponent} from './admin/admin.component';

const routes: Routes = [
      { path: '',  redirectTo: '/home', pathMatch: 'full' },
      {
        path:'adminlogin',
        component:AdminloginComponent
      },
      {
        path:'admin',
        component:AdminComponent
      },
    {
      path:'home',
      component:HomeComponent
    },
    {
      path:'about',
      component:AboutComponent
    },
    {
      path:'login',
      component:LoginComponent
    },
    {
      path:'signup',
      component:SignupComponent
    },
    {
      path:'user',
      component:UserComponent,
      canActivate:[ActivateGuard]
    },
    {
      path:'user/form',
      component:HeartComponent,
      canActivate:[ActivateGuard]
    },
    {
      path:'user/prediction',
      component:PredictionComponent,
      canActivate:[ActivateGuard]
    },


];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {}
